export default __webpack_public_path__ + "static/media/account.d5f4f996.svg";